import React from "react";
import { Button, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import DownloadIcon from "@mui/icons-material/Download";
import { useLocation } from "react-router-dom";
import {
  getEntrevistasExcel,
  getResultadosExcel,
  getCandidatosExcel,
} from "shared/features/api/export";
import { theme } from "shared/theme/index";

type ColorType = "primary" | "secondary";

interface ExportButtonProps {
  color?: ColorType;
}

export const Export: React.FC<ExportButtonProps> = ({ color = "secondary" }) => {
  const { pathname } = useLocation();
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));

  const checarPagina = () => {
    switch (pathname) {
      case "/agenda":
        getEntrevistasExcel();
        break;
      case "/resultado":
        getResultadosExcel();
        break;
      case "/candidatos":
        getCandidatosExcel();
        break;
      default:
        break;
    }
  };

  return (
    <Box display="flex" justifyContent="flex-end">
      	<Button
			variant="outlined"
			startIcon={!mdDown ? <DownloadIcon /> : undefined}
			sx={(theme) => ({
				color: color === "primary"
					? theme.palette.primary.main
					: theme.palette.secondary.light,
				borderColor: color === "primary"
					? theme.palette.primary.main
					: theme.palette.secondary.light,
				"&:hover": {
					color: color === "primary"
					? theme.palette.secondary.main
					: theme.palette.primary.light,
				},
			})}
			onClick={checarPagina}
			>
			{!mdDown && "Exportar lista"}
			{mdDown && <DownloadIcon />}
		</Button>
    </Box>
  );
};
